import React, { useEffect, useState } from "react";
import Index from "../../Index";
import "./defaultLayout.css";
import "./defaultLayout.responsive.css";
import PagesIndex from "../../../container/pages/business/PagesIndex";
import { useLocation, useNavigate } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const { hash } = useLocation();

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 40);
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    if (menuOpen) {
      document.body.classList.add("menu-open");
    } else {
      document.body.classList.remove("menu-open");
    }
  }, [menuOpen]);

  const handleMenuToggle = () => {
    setMenuOpen(true);
  };

  const handleOverlayClick = () => {
    setMenuOpen(false);
  };

  const handleLinkClick = (path) => {
    setMenuOpen(false);
    navigate(path);
  };

  useEffect(() => {
    if (hash === "#how-it-works") {
      const el = document.getElementById("how-it-works");
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [hash]);

  return (
    <>
      <Index.Box
        className={`header-user-main ${scrolled ? "scrolled-header" : ""}`}
      >
        <Index.Box className="user-header-main">
          <Index.Box className="flex-justify-box">
            <Index.Box className="user-header-flex">
              <Index.Box className="user-header-logo">
                <Index.Link className="user-header-logolink" to="/" onClick={e => {
                  e.preventDefault();
                  window.history.replaceState(null, '', '/');
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                  setMenuOpen(false);
                }}>
                  <img
                    src={PagesIndex.Png.logougoout}
                    alt="logougoout"
                    className="user-header-logoimg"
                  />
                </Index.Link>
              </Index.Box>

              <Index.Box
                className={`mobile-overlay ${menuOpen ? "active" : ""}`}
                onClick={handleOverlayClick}
              ></Index.Box>

              <Index.Box
                className={`user-header-menu ${menuOpen ? "active" : ""}`}
              >
                <Index.List className="user-header-list">
                  <Index.ListItem className="user-list-item-nav">
                    <Index.Link
                      className="redirect-link-user"
                      to="/"
                      onClick={e => {
                        e.preventDefault();
                        window.history.replaceState(null, '', '/');
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                        setMenuOpen(false);
                      }}
                    >
                      Home
                    </Index.Link>
                  </Index.ListItem>
                  <Index.ListItem className="user-list-item-nav">
                    {/* <Index.Link
                      className="redirect-link-user"
                      to="/"
                    // onClick={() => handleLinkClick("/home")}
                    > */}
                    <HashLink
                      className="redirect-link-user"
                      smooth
                      to="/#how-it-works"
                      onClick={(e) =>
                        setMenuOpen(false)
                      }
                    >
                      How it works
                    </HashLink>
                  </Index.ListItem>
                  <Index.ListItem className="user-list-item-nav">
                    <Index.Link
                      className="redirect-link-user"
                      to="/business-partner"
                      onClick={() => handleLinkClick("/business-partner")}
                    >
                      Become a partner
                    </Index.Link>
                  </Index.ListItem>
                </Index.List>
              </Index.Box>
            </Index.Box>

            <Index.Box className="header-btn-flex">
              <Index.Box className="header-btn-login">
                <Index.Button
                  className="login-btn-user"
                  onClick={() => navigate("/login")}
                >
                  Business portal Login{" "}
                  <img src={PagesIndex.Svg.blackrightarrow} alt="arrow" />
                </Index.Button>
              </Index.Box>

              <Index.Button
                className="mobile-btn-menu"
                onClick={handleMenuToggle}
              >
                <img src={PagesIndex.Svg.menu} alt="menu" />
              </Index.Button>
            </Index.Box>
          </Index.Box>
        </Index.Box>
      </Index.Box >
    </>
  );
};

export default Header;
